<template>
	<GatewaySettings gateway-name="sms" display-name="SMS" />
</template>

<script>
	import GatewaySettings from "../components/GatewaySettings.vue";

	export default {
		components: {
			GatewaySettings,
		}
	};
</script>
